var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCardDiscover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0401 275.463C36.975 279.794 30.527 281.687 20.216 281.687H15.9374V230.005H20.216C30.527 230.005 36.7276 231.771 42.0401 236.317C47.5239 241.016 50.8193 248.263 50.8193 255.76C50.8193 263.292 47.5239 270.798 42.0401 275.463ZM23.41 216.766H0V294.932H23.2672C35.6494 294.932 44.5871 292.112 52.4211 285.891C61.7267 278.522 67.2486 267.395 67.2486 255.869C67.2486 232.794 49.2336 216.766 23.41 216.766Z",
    fill: "#201D1C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.5972 216.766H90.4713V294.932H74.5972V216.766Z",
    fill: "#201D1C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.454 246.725C119.872 243.362 117.072 241.122 117.072 236.898C117.072 231.987 122.077 228.263 128.959 228.263C133.729 228.263 137.659 230.09 141.846 234.555L150.133 224.151C143.286 218.384 135.09 215.465 126.155 215.465C111.699 215.465 100.681 225.088 100.681 237.814C100.681 248.619 105.803 254.1 120.751 259.305C126.999 261.384 130.174 262.804 131.782 263.766C134.966 265.736 136.552 268.559 136.552 271.821C136.552 278.179 131.287 282.853 124.17 282.853C116.593 282.853 110.462 279.223 106.793 272.407L96.5227 281.925C103.865 292.219 112.666 296.82 124.792 296.82C141.329 296.82 152.981 286.225 152.981 271.135C152.981 258.701 147.577 253.065 129.454 246.725Z",
    fill: "#201D1C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.986 255.869C157.986 278.856 176.842 296.668 201.114 296.668C207.959 296.668 213.826 295.375 221.051 292.113V274.149C214.667 280.289 209.063 282.71 201.812 282.71C185.773 282.71 174.412 271.605 174.412 255.76C174.412 240.788 186.141 228.928 201.114 228.928C208.669 228.928 214.442 231.489 221.051 237.72V219.777C214.071 216.399 208.343 215 201.441 215C177.308 215 157.986 233.161 157.986 255.869Z",
    fill: "#201D1C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M350.112 269.244L328.329 216.766H310.961L345.59 296.905H354.131L389.431 216.766H372.2L350.112 269.244Z",
    fill: "#201D1C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M396.66 294.932H441.834V281.687H412.597V260.588H440.723V247.346H412.597V230.004H441.834V216.766H396.66V294.932Z",
    fill: "#201D1C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M472.947 252.71H468.323V229.067H473.207C483.16 229.067 488.492 233.064 488.492 240.679C488.492 248.503 483.16 252.71 472.947 252.71ZM504.895 239.829C504.895 225.191 494.404 216.766 476.011 216.766H452.351V294.932H468.323V263.505H470.394L492.402 294.932H512L486.3 261.987C498.311 259.638 504.895 251.79 504.895 239.829Z",
    fill: "#201D1C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.207 256.051C313.207 278.555 294.152 296.795 270.624 296.795C247.103 296.795 228.045 278.555 228.045 256.051C228.045 233.543 247.103 215.3 270.624 215.3C294.152 215.3 313.207 233.543 313.207 256.051Z",
    fill: "url(#paint0_linear_2_47)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M313.207 256.051C313.207 278.555 294.152 296.795 270.624 296.795C247.103 296.795 228.045 278.555 228.045 256.051C228.045 233.543 247.103 215.3 270.624 215.3C294.152 215.3 313.207 233.543 313.207 256.051Z",
    fill: "url(#paint1_radial_2_47)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_47",
    x1: 244.5,
    y1: 223,
    x2: 297.5,
    y2: 287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6772F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA9D2C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2_47",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(280 273) rotate(-128.1) scale(55.9129 58.4286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EA9D2C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328125,
    stopColor: "#DF7624",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.760188,
    stopColor: "#BF4B23",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7D3017"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCardDiscover);
export default __webpack_public_path__ + "static/media/icon-card-discover.4487c2e148f086fa4185c903bf979687.svg";
export { ForwardRef as ReactComponent };